export enum ComplaintType {
  /**
   * 参与方投诉委托方
   */

  COMPLAINT_ENTRUST = 0,

  /**
   * 委托方投诉参与方
   */
  COMPLAINT_PARTICIPANT = 1
}

export const ComplaintTypeTextMap = {
  [ComplaintType.COMPLAINT_ENTRUST]: '参与方投诉委托方',
  [ComplaintType.COMPLAINT_PARTICIPANT]: '委托方投诉参与方'
}

export const ComplaintTypeColorMap = {
  [ComplaintType.COMPLAINT_ENTRUST]: 'blue',
  [ComplaintType.COMPLAINT_PARTICIPANT]: 'orange'
}
